import React, { useState } from "react";
import { Link } from "react-router-dom";
import './EmailVerification.css';
import { useParams,useLocation } from 'react-router-dom';
import { Button } from "@mui/material";
import backgroundImage from "../../src/images/bk3.jfif"; // Change the path accordingly


var config = require("../config/dev").default;




const EmailVerification = (props) => {
    console.log("propsatemail",props);
    const { userId } = useParams();
    const location = useLocation();

    console.log("userId",userId);

    const handleResetPasswordClick = () => {
        window.location.href = config.Local_ENDPOINT + `resetpassword/` + userId;
      };
    
    return (     

        <div className="container"
        style={{
            backgroundImage: `url(${backgroundImage})`, // Set the background image
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            maxHeight: "100%", // Ensure the background covers the entire viewport
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        > 
        {/* <div className="row"> */}
            {/* <div className="col-10 col-md-6">
                <img src={require("../images/email5.jpg")} className="img" />
            </div> */}
            <div className="col-11">
            <div className="col textregister">
                <h2 className="h2register">EMAIL VERIFICATION</h2>
            </div>
                <form  className="form-outline formclass">
                    <br></br>
                    <h2 className="fontclass" style={{ fontSize: '18px'}}>Thank you for signing up!!</h2>
                    <h2 className="fontclass" style={{ fontSize: '18px'}}>You will receive an email shortly with an OTP on your registered Email ID!</h2>
                    <br></br>
                    <br></br>
                    <h2 className="h2class" style={{ fontSize: '14px'}}>If you do not receive your confirmation email, please check your spam or junk mail box of your email client</h2>
                </form>
                <br></br>
                
                <div className="button-container" style={{ textAlign: 'center'}}>
                <Button 
                //  className="buttonresetpasswordmodal" style={{marginLeft: "490px"}}
                className="buttonresetpasswordmodal font-change" style={{marginTop: "20px", fontSize:"5px" }}
                 onClick={handleResetPasswordClick}>
                  RESET PASSWORD
                </Button>
                </div>
                </div>
                
            </div>
        // </div>
);
}



export default EmailVerification;

